<template>
  <v-dialog
    persistent
    :max-width="width"
    :value="show"
    @keydown.esc="$emit('close')"
  >
    <v-card>
      <v-card-title class="py-0">
        <v-sheet width="100%" height="56">
          <v-layout row align-center justify-space-between fill-height>
            <h4>
              Resumo da Fatura
            </h4>
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('close')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-sheet>
      </v-card-title>
      <v-divider />
      <template>
        <div class="body-modal">
          <visualizar-parcelamento v-bind="{ visualizaParcelamento }" />
        </div>
        <v-divider class="bg-neutral-gray-medium" />
        <v-card-actions>
          <v-sheet width="100%" height="48">
            <v-layout row align-center justify-end fill-height>
              <v-btn
                :color="highContrast ? 'white' : 'primary'"
                @click="onClickRelatorioAnalitico"
              >
                Relatório Analítico
              </v-btn>
              <v-btn
                :color="highContrast ? 'white' : 'primary'"
                @click="onClickRelatorioSintetico"
              >
                Relatório Sintético
              </v-btn>
            </v-layout>
          </v-sheet>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const portalStore = createNamespacedHelpers("portal");
import { relatorioParcelamento } from "@/services/plapiconnect";

import VisualizarParcelamento from "./visualizar-parcelamento";

export default {
  name: "ModalVisualizarParcelamento",
  props: {
    title: String,
    codigoParcelamento: String,
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "704"
    }
  },
  components: {
    VisualizarParcelamento
  },
  computed: {
    ...portalStore.mapState(["visualizaParcelamento", "highContrast"])
  },
  methods: {
    async onClickRelatorioAnalitico() {
      const payload = `{"codigoParcelamento": ${
        this.codigoParcelamento
      }, "opcao": "A"}`;

      await relatorioParcelamento({ payload }, this.$store);
    },
    async onClickRelatorioSintetico() {
      const payload = `{"codigoParcelamento": ${
        this.codigoParcelamento
      }, "opcao": "S"}`;

      await relatorioParcelamento({ payload }, this.$store);
    }
  }
};
</script>
<style lang="scss" scoped>
.body-modal {
  padding: 40px;
  height: 500px;
  overflow: auto;
}
</style>
